import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import AppLoading from "./AppLoading";

export default function ShowRefImage({ billId, show, onHide, status }) {
 
  const API_URL = "https://akulcreations.com/api/AkulCreationsAPI.php";

  const [loading, setLoading] = useState(false);
  const [refImg, setRefImg] = useState([]);
  const [error, setError] = useState(null);

  console.log(status);

useEffect(() => {
  if (show && billId) {
    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("tag", "GetOrderImagesByBill");
    formData.append("billId", billId);

    axios
      .post(API_URL, formData)
      .then((response) => {
        setRefImg(response.data);   // response is ARRAY (Spring Boot style)
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
        setError("Failed to load images.");
        setLoading(false);
      });
  }
}, [show, billId]);


  // Function to delete an image
  const handleDelete = (imageId) => {
  if (window.confirm("Are you sure you want to delete this image?")) {
    setLoading(true);

    const formData = new FormData();
    formData.append("tag", "DeleteImage");
    formData.append("imageId", imageId);

    axios
      .post(API_URL, formData)
      .then(() => {
        // remove image from UI
        setRefImg(prev => prev.filter(img => img.id !== imageId));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting image", error);
        setError("Failed to delete the image.");
        setLoading(false);
      });
  }
};


  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>View Images</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <AppLoading />}
        {error && <p className="text-danger">{error}</p>}
        {!loading && !error && refImg.length > 0 && (
          <Row className="my-4 m-0">
            {refImg.map((image) => (
              <Col key={image.id} xs={12} sm={12} md={12}>
                <Card className="my-2 position-relative">
                  <Card.Img src={image.image} alt={image.id} className="w-100" />
                  <Card.Body>
                    <Card.Text>
                      <b>Image For: </b>
                      {image?.item?.item || 'N/A'}
                    </Card.Text>
                    <Card.Text>
                      <b>Options: </b>
                      {image?.options ? (
                        <ul>
                          {image.options.split(",").map((option, index) => (
                            <li key={index}>{option.trim()}</li>
                          ))}
                        </ul>
                      ) : (
                        <li>No Options available</li>
                      )}
                    </Card.Text>
                    <Card.Text>
                      <b>Description: </b>
                      {image?.description || 'No description available'}
                    </Card.Text>
                    <Card.Text>
                      <b className="text-danger">Uploaded By: </b>
                      {image?.uploaded || 'No data available'}
                    </Card.Text>
                    <Card.Text>
                      <b >Uploaded Date & Time: </b>
                      {image?.date || 'No data available'}
                    </Card.Text>
                   { status === "Pending" && (
                     <Button variant="danger" onClick={() => handleDelete(image.id)}>
                     Delete
                   </Button>
                   )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        {!loading && !error && refImg.length === 0 && <p>No images available.</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
